import React from 'react';
import classNames from 'classnames';
import CircularProgressMui from '@mui/material/CircularProgress';
import './index.scss';

type CircularProgressProps = {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
};

export const CircularProgress: React.FC<CircularProgressProps> = ({ size = 20, className = '', style }) => (
  <div className="circular-progress" {...(style && { style })}>
    <CircularProgressMui className={classNames('circular-progress--spinner', className)} size={size} />
  </div>
);
